export type ReceivedProps = Record<string, any>;

const useAttendance = () => {
  return {};
};

export type Props = ReturnType<typeof useAttendance>;

export default useAttendance;
